
import XButton from 'vux/src/components/x-button/index.vue'

import {Fetch} from "../../utils/storage"
import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"
import Pay from '../../utils/pay'

export default {
name: 'MemberUserOrder-New',
components: {
XButton
},
filters: {
/**
* @return {string}
*/
MeetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
}

},
data () {
return {
Committee:{},
CommitteeID: 0,
MemberUser: {},
MeetingList: [],
IsShowNotFound: false,
PositionMap: {
"chairman": "主委员",
"vice_chairman": "副委员",
"secretary_general": "秘书长",
"secretary": "秘书"
},
StatusMap: {
"valid": "有效",
"invalid": "未开通会员",
},
isMemberValid: false
}
},
created () {
this.CommitteeID = this.$route.params["committee_id"]
if (!this.CommitteeID) this.$router.go(-1)
this.CommitteeID = parseInt(this.CommitteeID)
this.UserID = Fetch("ID")
this.FetchCommitteeDetail()

this.FetchMemberUser()
},
methods: {
ParseTime,
async FetchMemberUser() {
let _this = this
let CommitteeID = _this.CommitteeID
let UserID = _this.UserID
let memberRet = await Api('GetMemberUserList', {
Data:{
UserID: UserID,
CommitteeID: CommitteeID
},
Limit:1000,
})
if (memberRet.data.List && memberRet.data.List[0].Status == 'valid') {
_this.isMemberValid = true
_this.MemberUser = memberRet.data.List[0]
}
},
async FetchCommitteeDetail() {
let _this = this
let res = await Api('GetCommitteeList',{
Data:{
ID:_this.CommitteeID,
}

})
if (res.data.List && res.data.List.length == 1) {
_this.Committee = res.data.List[0]
} else {
_this.$vux.toast.show({
text:'获取专委会信息出错',
type:'cancel',
})
_this.$router.go(-1)
}
},
async handleToEnroll() {
let _this = this
let CommitteeID = this.CommitteeID
let UserID = this.UserID
let userRes = await Api('GetInfo',{
})
if (! userRes.data) {
this.$vux.toast.show({
text:'获取用户信息错误，请稍后再试！',
type:'cancel',
})
return
}
if (!userRes.data || !userRes.data.IDCard || !userRes.data.PhoneNumber || !userRes.data.Name || !userRes.data.Email) {
_this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">用户信息未完善, 为保证您正常报名, 请完善个人信息</span>`,
confirmText:"去完善",
async onConfirm(){
_this.$router.push("/user/info/edit")
}
})
return
}
_this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">确认是否参加此专委会? 点击『我要报名』进行付款</span>`,
confirmText:"我要报名",
async onConfirm(){
try {
_this.$vux.loading.show({
text: '订单正在创建'
})
let createRes = await Api('CreateMemberUserOrder', {
UserID: UserID,
CommitteeID: CommitteeID
})
_this.$vux.loading.hide()
if (!createRes.data.IDs) {
_this.$vux.toast.show({
text: '创建订单失败',
type: 'cancel'
})
}
_this.handleWechatPay(createRes.data.IDs[0])

} catch(err) {
_this.$vux.loading.hide()
if(err.message) {
_this.$vux.toast.show({
text: err.message,
type: 'cancel'
})
}
}
}
})


},
async handleWechatPay(OrderID) {
if (true) {
let _this = this
try{
let res = await Api ('MemberUserOrderFakeSuccess', {
OrderID: OrderID
})
_this.$vux.toast.show({
text: '专委会会员报名并缴费成功！',
type: 'text',
width:'3rem'
})
_this.$router.go(0)

}catch (err) {
console.log(err)
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">获取支付请求失败</span>',
showCancelButton:false,
})
}
return

}

try{
let _this = this
let res = await Api('GetMemberUserOrderPrePay', {
OrderID: OrderID
})

Pay.invoke(
res.data,
function (){
_this.$vux.toast.show({
text: '专委会会员报名并缴费成功！',
type: 'text',
width:'3rem'
})
_this.$router.replace(`/member-user-order/detail/${OrderID}`)

},
function (){
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">微信支付失败</p>
<span style="font-size:20px">报名申请已经提交，但费用支付失败。点击下方左侧进行"重新支付",或点击右侧"查看详情"</span>
`,
confirmText:"查看详情",
cancelText:"重新支付",
onCancel(){

_this.handleWechatPay(OrderID)
},
onConfirm() {

_this.$router.replace(`/member-user-order/detail/${OrderID}`)
}
})
}
)
}catch(err){
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">获取支付请求失败</span>',
showCancelButton:false,
})

}
},
}
}
